import { MetricConfig } from '@/types/evals';
import { getMetricType } from '@/utils/metricUtils';

import { InfoCard } from '../../_components/InfoCard';
import { InfoCardRow } from '../../_components/InfoCardRow';

type Props = {
  config: MetricConfig;
};

export function MetricMetaRow( { config }: Props ) {
  const { configuration } = config;

  return (
    <InfoCardRow data-testid="metric-meta-row">
      <InfoCard label="Metric Type" value={ getMetricType( configuration ) } />
      { 'modelParameters' in configuration && (
        <>
          <InfoCard label="Model Name" value={ configuration.modelParameters.model } />
          <InfoCard label="Model Temperature" value={ configuration.modelParameters.temperature } />
        </>
      ) }
      { 'url' in configuration && (
        <InfoCard
          label="Async Metric"
          value={ configuration.isAsync === undefined ? '—' : String( configuration.isAsync ) }
        />
      ) }
      <InfoCard label="Example Types" value={ config.exampleType.join( ', ' ) } />
    </InfoCardRow>
  );
}
